import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { GridAction } from '../model/result-grid/grid-action';

@Injectable({
  providedIn: 'root'
})
export class ResultGridActionsService {

  public resultActionCallback:Subject<any> = new Subject();
  public gridActionItems:Subject<GridAction[]>  = new Subject();
  public gridCancelItems:Subject<GridAction[]>  = new Subject();

  public callActionCallback(action: any) {
    this.resultActionCallback.next({callFunction : action});
    return true;
  }
}
